module.exports = __webpack_public_path__ + "img/product-grey.720684c9.svg";